module.exports = __webpack_public_path__ + "static/media/undo.045e278d.svg";